import { HttpInterceptorFn } from '@angular/common/http';
import {
  apiCultureFor,
  resolveInitialLanguage,
} from '@core/services/language/language-preferences';

export const cultureInterceptor: HttpInterceptorFn = (req, next) => {
  return next(
    req.clone({
      setHeaders: {
        'Use-Culture': apiCultureFor(resolveInitialLanguage()),
      },
    })
  );
};
